'use client';

import Link from 'next/link';
import {
  ReactNode,
  AnchorHTMLAttributes,
  forwardRef,
} from 'react';
import useIsIframe from '../../hooks/use-is-iframe';

interface OWLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: ReactNode;
}

const NextLink = forwardRef<HTMLAnchorElement, OWLinkProps>(({
  href,
  children,
  target,
  rel,
  ...rest
}, ref) => {
  const isIframe = useIsIframe();

  const finalTarget = isIframe ? '_blank' : target;
  const secureRel =
    finalTarget === '_blank' && !rel ? 'noopener noreferrer' : rel;

  return (
    <Link
      href={href}
      target={finalTarget}
      rel={secureRel}
      ref={ref}
      {...rest}
    >
      {children}
    </Link>
  );
});

export default NextLink;
